export default __webpack_public_path__ + "static/404-0725f78c7394ae19e404a92f679d00c6.jpg";